module.exports = [{
  name: "Midnight Snow",
  id: 0
}];